import { render, staticRenderFns } from "./AdminHiring.vue?vue&type=template&id=ef1b0068&scoped=true&"
import script from "./AdminHiring.vue?vue&type=script&lang=js&"
export * from "./AdminHiring.vue?vue&type=script&lang=js&"
import style0 from "./AdminHiring.vue?vue&type=style&index=0&id=ef1b0068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1b0068",
  null
  
)

export default component.exports